// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// Wishlist Hero stores a variant ID, but its cards do not expose the variant title.
// Read that ID from the card link and use the shared quick-add for explicit size choices.
(() => {
  const selector = '.wishlist-hero-list-card';
  const products = new Map();
  const de = document.documentElement.lang.startsWith('de');
  const text = de
    ? { saved: 'Gemerkt', sold: 'Ausverkauft', choose: 'Größe wählen', add: 'Größe wählen & hinzufügen', fallback: 'Größe auf Produktseite wählen', default: 'Einheitsgröße' }
    : { saved: 'Saved', sold: 'Sold out', choose: 'Choose size', add: 'Choose size & add', fallback: 'Choose size on product page', default: 'One size' };
  function getProduct(url) {
    if (!products.has(url)) {
      products.set(url, fetch(url).then(response => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).catch(error => { products.delete(url); throw error; }));
    }
    return products.get(url);
  }
  async function enhance(card) {
    const link = card.querySelector('.wishlist-hero-list-card-header-product-name');
    const footer = card.querySelector('.wishlist-hero-list-card-footer');
    if (!link || !footer) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return;
    const existing = card.querySelector('.sp-wishlist-variants');
    if (existing?.dataset.source === url.href) return;
    existing?.remove();
    const box = document.createElement('div');
    box.className = 'sp-wishlist-variants';
    box.dataset.source = url.href;
    // The app reuses card nodes when sorting. Never attach an old response to a new product.
    const current = () => box.isConnected && card.querySelector('.wishlist-hero-list-card-header-product-name')?.href === url.href;
    const fallback = document.createElement('a');
    fallback.href = link.href;
    fallback.textContent = text.fallback;
    box.append(fallback);
    footer.before(box);
    card.classList.add('sp-wishlist-has-variants');
    try {
      const product = await getProduct(`${url.pathname}.js`);
      if (!current()) return;
      const variants = product.variants || [];
      const saved = variants.find(variant => String(variant.id) === url.searchParams.get('variant'));
      const title = variant => variant.public_title || (variant.title === 'Default Title' ? text.default : variant.title);
      const savedLabel = document.createElement('p');
      savedLabel.className = 'sp-wishlist-variants__saved';
      savedLabel.textContent = saved ? `${text.saved}: ${title(saved)}${saved.available ? '' : ` · ${text.sold}`}` : '';
      box.prepend(savedLabel);
      // Subscription-only items retain the product-page path for their selling plan.
      if (!variants.length || product.requires_selling_plan) return;
      await customElements.whenDefined('sp-inline-quick-add');
      if (!current()) return;
      const control = document.createElement('sp-inline-quick-add');
      control.hidden = true;
      control.innerHTML = '<button type="button" class="sp-inline-quick__toggle" aria-expanded="false"><b></b><span aria-hidden="true"></span></button><div class="sp-inline-quick__panel" inert><div class="sp-inline-quick__clip"><div class="sp-inline-quick__options" role="group"></div><p class="sp-inline-quick__status" role="status" aria-live="polite"></p></div></div>';
      const toggle = control.querySelector('button');
      toggle.setAttribute('aria-label', `${text.add}: ${product.title}`);
      toggle.querySelector('b').textContent = text.choose;
      const options = control.querySelector('.sp-inline-quick__options');
      options.setAttribute('aria-label', text.add);
      variants.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.variant = String(variant.id);
        button.dataset.quantity = String(variant.quantity_rule?.min || 1);
        button.dataset.addedLabel = title(variant);
        button.disabled = !variant.available;
        button.textContent = title(variant);
        button.setAttribute('aria-label', `${title(variant)} · ${variant.available ? (de ? 'In den Warenkorb' : 'Add to bag') : text.sold}`);
        options.append(button);
      });
      fallback.replaceWith(control);
    } catch {
      // The visible product-page link remains usable if the product request fails.
    } finally {
      if (box.isConnected && !current()) { box.remove(); enhance(card); }
    }
  }
  function scan(root) {
    if (root.nodeType !== 1 && root !== document) return;
    const card = root.closest?.(selector);
    if (card) enhance(card);
    root.querySelectorAll?.(selector).forEach(enhance);
  }
  scan(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.target.closest?.(selector)) scan(record.target);
    record.addedNodes.forEach(scan);
  })).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();
